import { useMutation } from '@tanstack/react-query';
import { toast } from 'react-toastify';

import { showErrorToast } from '@hooks/showErrorToast';
import { apiClient } from '@utils';
import { queryClient } from '../../queryClient';

interface HookProps {
  batchId: string;
}

export const useRunRiskAnalysisCalculations = () => {
  return useMutation({
    mutationFn: async ({ batchId }: HookProps) => {
      const result = await apiClient.batchesReports.runRiskAnalysisCalculations.query({ params: { id: batchId } });
      if (result.status !== 200) throw result.body;
    },
    onSuccess: () => {
      toast.success('Successfully ran the risk analysis calculations');
    },
    onError: (error) => {
      queryClient.invalidateQueries({ queryKey: ['batches'] });
      showErrorToast(error, 'Risk analysis calculations failed!');
    },
  });
};
